import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink, PrimaryButton } from '../../../components';
import notFoundImage from '../../../assets/not-found-image.png';

import css from './NoSearchResultsMaybe.module.css';

const NoSearchResultsMaybe = props => {
  const { listingsAreLoaded, totalItems, location, resetAll, showCreateListingsLink } = props;
  const hasNoResult = listingsAreLoaded && totalItems === 0;
  const hasSearchParams = location.search?.length > 0;

  const createListingLinkMaybe = showCreateListingsLink ? (
    <NamedLink className={css.createListingLink} name="NewListingPage">
      <FormattedMessage id="SearchPage.createListing" />
    </NamedLink>
  ) : null;

  return hasNoResult ? (
    <div className={css.noSearchResults}>
      <img
        src={notFoundImage}
        alt="No results found"
        className={css.notFoundImage}
      />
      <h3>
        <FormattedMessage id="SearchPage.noResults" />
      </h3>
      <p>
        <FormattedMessage id="SearchPage.adjustFilters" />
      </p>
      {hasSearchParams ? (
        <PrimaryButton onClick={e => resetAll(e)}>
          <FormattedMessage id={'SearchPage.resetAllFiltersButton'} />
        </PrimaryButton>
      ) : null}
    </div>
  ) : null;
};

export default NoSearchResultsMaybe;
